import {
  FileInputProps as MantineFileInputProps,
  FileInput as MantineFileInput,
} from '@mantine/core';

export type FileInputProps = MantineFileInputProps;

export const FileInput = MantineFileInput;

(FileInput as { displayName?: string }).displayName = 'FileInput';
